var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666687 2.33325C0.666687 1.80282 0.877401 1.29411 1.25247 0.919038C1.62755 0.543966 2.13625 0.333252 2.66669 0.333252H9.33335C9.86379 0.333252 10.3725 0.543966 10.7476 0.919038C11.1226 1.29411 11.3334 1.80282 11.3334 2.33325V12.4253C11.3334 12.6004 11.2875 12.7725 11.2001 12.9244C11.1127 13.0762 10.987 13.2024 10.8355 13.2904C10.684 13.3783 10.5121 13.425 10.3369 13.4256C10.1617 13.4262 9.98946 13.3808 9.83735 13.2939L6.33069 11.2899C6.22998 11.2324 6.116 11.2021 6.00002 11.2021C5.88404 11.2021 5.77006 11.2324 5.66935 11.2899L2.16269 13.2939C2.01058 13.3808 1.83832 13.4262 1.66314 13.4256C1.48797 13.425 1.31603 13.3783 1.16454 13.2904C1.01305 13.2024 0.88733 13.0762 0.799957 12.9244C0.712583 12.7725 0.666627 12.6004 0.666687 12.4253V2.33325ZM8.00002 4.99992C8.17683 4.99992 8.3464 5.07016 8.47143 5.19518C8.59645 5.32021 8.66669 5.48977 8.66669 5.66659C8.66669 5.8434 8.59645 6.01297 8.47143 6.13799C8.3464 6.26301 8.17683 6.33325 8.00002 6.33325H4.00002C3.82321 6.33325 3.65364 6.26301 3.52862 6.13799C3.40359 6.01297 3.33335 5.8434 3.33335 5.66659C3.33335 5.48977 3.40359 5.32021 3.52862 5.19518C3.65364 5.07016 3.82321 4.99992 4.00002 4.99992H8.00002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.a6f2123390154abba84e30fd81d07c63.svg";
export { ForwardRef as ReactComponent };